var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileBackground(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 436,
    height: 549,
    viewBox: "0 0 436 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1175",
    x: 0,
    y: 0,
    width: 436,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(-310 -1457)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 310, 1457)",
    filter: "url(#Path_1175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175-2",
    "data-name": "Path 1175",
    d: "M15,0H397a15,15,0,0,1,15,15V510a15,15,0,0,1-15,15H15A15,15,0,0,1,0,510V15A15,15,0,0,1,15,0Z",
    transform: "translate(12 4)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "matrix(0.99, -0.139, 0.139, 0.99, 264.591, 1440.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(42.507 307.29)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 10.677,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.677,
    cy: 10.677,
    r: 9.677,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(379.962 264.042)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 7.868,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.868,
    cy: 7.868,
    r: 6.868,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(91.165 272.091)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.931,
    cy: 6.931,
    r: 6.931,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.931,
    cy: 6.931,
    r: 5.931,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    transform: "translate(68.1 433.086)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.931,
    cy: 6.931,
    r: 6.931,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.931,
    cy: 6.931,
    r: 5.931,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(358.774 100.99)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(63.506 112.266)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    transform: "translate(352.442 459.861)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 5.62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62,
    cy: 5.62,
    r: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 20.231,
    y2: 22.479,
    transform: "translate(341.248 348.151)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 19.107,
    y2: 16.859,
    transform: "translate(116.485 48.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0,7.372,27.235",
    transform: "translate(429.145 122.591)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 14.727,
    y2: 3.817,
    transform: "translate(263.683 69.531)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x1: 16.942,
    y2: 12.766,
    transform: "translate(321.682 557.439)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x2: 14.727,
    y2: 3.817,
    transform: "translate(27.683 390.812)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 14.727,
    y2: 3.817,
    transform: "translate(20.242 511.32)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBackground);
export default __webpack_public_path__ + "static/media/ProfileBackground.14984639dfe5a85302e489406edc7292.svg";
export { ForwardRef as ReactComponent };